import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import EmptyBox from 'components/atoms/icons/empty-box';

import s from './PageStates.module.scss';

import type { FC } from 'react';

interface INoResultsStateProps {
  onClearFilters: () => void;
}

const NoResultsState: FC<INoResultsStateProps> = ({ onClearFilters }) => {
  const { t } = useTranslation();

  return (
    <div className={s['empty-state-container']} data-cy="no-results-state">
      <EmptyBox />
      <p className={s['empty-state-heading']}>
        {t('tasksDashboard.noResults.title')}
      </p>
      <p className={s['empty-state-body']}>
        {t('tasksDashboard.noResults.description')}
      </p>
      <Button onClick={onClearFilters} style={{ marginTop: 16 }}>
        {t('tasksDashboard.filters.clearFilters')}
      </Button>
    </div>
  );
};

export default NoResultsState;
